// Guarda las UTM de la visita en los atributos del carrito para que salgan en el pedido
// (Detalles adicionales) aunque el cliente compre días después. No guarda datos personales.
(() => {
  const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const STORE = 'bdh_utm';
  const SYNCED = 'bdh_utm_synced';
  const TTL_MS = 7 * 24 * 60 * 60 * 1000;

  const leer = () => {
    try {
      const guardado = JSON.parse(localStorage.getItem(STORE) || 'null');
      if (guardado && Date.now() - guardado.guardadoEn < TTL_MS) return guardado;
      localStorage.removeItem(STORE);
    } catch (error) {
      /* sin almacenamiento: seguimos solo con la visita actual */
    }
    return null;
  };

  const params = new URLSearchParams(window.location.search);
  const nuevas = {};
  KEYS.forEach((clave) => {
    const valor = params.get(clave);
    if (valor) nuevas[clave] = valor.slice(0, 100);
  });

  let datos = leer();
  if (Object.keys(nuevas).length > 0) {
    datos = { atributos: { ...nuevas, utm_landing: window.location.pathname }, guardadoEn: Date.now() };
    try {
      localStorage.setItem(STORE, JSON.stringify(datos));
      sessionStorage.removeItem(SYNCED);
    } catch (error) {
      /* sin almacenamiento */
    }
  }
  if (!datos) return;

  try {
    if (sessionStorage.getItem(SYNCED) === '1') return;
  } catch (error) {
    /* sin almacenamiento: se intenta igual */
  }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: datos.atributos }),
  })
    .then((respuesta) => {
      if (respuesta.ok) {
        try {
          sessionStorage.setItem(SYNCED, '1');
        } catch (error) {
          /* sin almacenamiento */
        }
      }
    })
    .catch(() => {});
})();
